export default __webpack_public_path__ + "static/media/bg-2x.85d8f6e3.png";